import NoteDetail from "../AdjustmentNotes/NoteDetail";
import "./creditDesign.css";
export default function AdjustmentCreditDetail() {
  return <NoteDetail credit />;
}
